var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7414 45.1017C39.0618 45.1017 46.5545 37.6034 46.5545 24.2736C46.5545 10.9436 39.0618 3.44556 25.7414 3.44556C12.421 3.44556 4.92832 10.9436 4.92832 24.2736C4.92832 28.343 5.62664 31.8689 6.97588 34.8039L3.55341 44.2226C3.05756 45.5872 4.35541 46.9212 5.73189 46.4623L15.5318 43.1933C18.4012 44.4514 21.8186 45.1017 25.7414 45.1017Z",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7144 18.8931C20.9089 12.9968 15.8351 17.1863 15.7683 21.7026C15.7683 28.426 23.8128 33.9446 25.7144 33.9446C27.6159 33.9446 35.6606 28.426 35.6606 21.7026C35.5936 17.1863 30.5199 12.9968 25.7144 18.8931Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7144 18.8931C20.9089 12.9968 15.8351 17.1863 15.7683 21.7026C15.7683 28.426 23.8128 33.9446 25.7144 33.9446C27.6159 33.9446 35.6606 28.426 35.6606 21.7026C35.5936 17.1863 30.5199 12.9968 25.7144 18.8931Z",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirmation);
export default __webpack_public_path__ + "static/media/affirmation.4b0773f31bbfa0f19856060d25dddb9a.svg";
export { ForwardRef as ReactComponent };